export const getIsArchivedFromURL = () => {
  return window.location.search.split('archived=')[1]
    ? window.location.search.split('archived=')[1] === 'true'
    : false;
};
